
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/notifications",
      function () {
        return require("private-next-pages/notifications.js");
      }
    ]);
  